<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    会展中心站<br>
站点介绍<br>
会展中心站位于深圳市中心区福华路与中心五路交汇处，是深圳地铁1号线与4号线规模最大的换乘车站，东北侧有大中华国际交易广场，东南侧为商业办公区，西北侧和西南侧为商业区，车站地下与14.5万平方米福华路地下商业街结合，形成中心区又一璀璨景观。本车站地处深圳市中心区，紧邻气势宏伟的大中华国际交易广场和地势起伏、层次变化的大片高架绿地，优美的地面环境。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:09	23:54	1号线	2分钟	4分40秒<br>
机场东	06:35	23:15	1号线	2分钟	4分40秒<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:09	23:52	1号线	3分45秒	5分45秒<br>
机场东	06:34	23:14	1号线	3分45秒	5分45秒<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:09	00:52	1号线	3分45秒	5分45秒<br>
机场东	06:34	00:14	1号线	3分45秒	5分45秒<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道、福华路北侧（东）、金田路（北）、大中华国际广场、深圳大中华喜来登酒店、连城新天地岗会区间、Linkcity美食广场、卓悦中心、大百汇广场<br><br>
B出入口:<br>
福华路北侧（西）、中心五路西侧、福华一路、福田高铁站、领展中心城、福田香格里拉大酒店、连城新天地会购区间<br><br>
C出入口:<br>
中心四路、福华路南侧（西）、皇庭广场<br><br>
D出入口:<br>
中心五路（南）、福华三路北侧、会展中心、深圳星河丽思卡尔顿酒店<br><br>
E出入口:<br>
福华路南侧（东）、中心五路（北）、金田路（南）、深圳皇庭V酒店、南洋商业银行<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 大中华交易广场<br>
371路、64路、M347路、N9路、390路、60路、m454路、41路、E38路、M192路、M459路、M500路、M588路、高快巴士47路、高快巴士31路<br><br>
B出入口:<br>
公交站名： 会展中心地铁站<br>
3路、64路、E10路、E25路、M192路、M194路、M224路、M329路、M454路、M459路、M588路、高峰专线23路、高峰专线29路、高快巴士31号C出入口<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sihaoxian",
          title: "4号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>













